import { useAccountSelf } from 'App/components/hooks/appHooks';
import { useAssistantPermissions } from 'App/components/hooks/useAssistantPermissions';
import { hasAiWorkspaceLicence } from 'App/helpers/navSections';

// Single source of truth for who may use the floating chat. Shared by the sidebar button, the
// global Cmd/Ctrl+U shortcut, the window itself and quick search's AI action so the gates can't
// drift. The licence is the /ai-workspace route's gate; the per-user canAccessWorkspace grant is
// enforced inside the workspace and by the server-side aiWorkspaceGuard, the real boundary.
export function useFloatingChatAccess(): boolean {
	const accountSelf = useAccountSelf();
	const assistantPerms = useAssistantPermissions();
	return hasAiWorkspaceLicence(accountSelf) && assistantPerms?.canAccessWorkspace === true;
}
